module.exports = __webpack_public_path__ + "static/img/integral.44c89da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integral.png
// module id = MM3+
// module chunks = 2